module.exports = __webpack_public_path__ + "static/media/face_with_tears_of_joy.e9e6cd89.png";